import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { initSentry } from '@/lib/sentry'
import { initWebVitals } from '@/lib/web-vitals'
import './styles/globals.css'

initSentry()

// Auto-reload once on chunk load failure (stale deploy cache)
const CHUNK_RELOAD_KEY = 'chunk-reload-attempted'

window.addEventListener('load', () => sessionStorage.removeItem(CHUNK_RELOAD_KEY))

function handleChunkError(event: Event | PromiseRejectionEvent) {
  const error = 'reason' in event ? event.reason : (event as ErrorEvent).error
  if (
    error instanceof Error &&
    (error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('Loading chunk') ||
      error.name === 'ChunkLoadError')
  ) {
    if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true')
      event.preventDefault()
      window.location.reload()
    }
  }
}

window.addEventListener('error', handleChunkError)
window.addEventListener('unhandledrejection', handleChunkError)
// Vite dispatches this for failed dynamic imports / modulepreloads.
window.addEventListener('vite:preloadError', (event) => {
  if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true')
    event.preventDefault()
    window.location.reload()
  }
})

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  )

  initWebVitals()
}
